
let cacheObject = {
    promise: {

    },
    results: {

    }
};

const SetPromiseSession = (promise) => {
    cacheObject.promise['getSession'] = promise;
};
const GetPromiseSession = () => {
    return cacheObject.promise['getSession'];
};

const SetResultSession = (result) => {
    cacheObject.results['getSession'] = result;
};

const GetSession = () => {
    if (cacheObject.results['getSession']) {
        return Promise.resolve(cacheObject.results['getSession']);
    }

    return cacheObject.promise['getSession'];
};

const SessionService = {
    SetPromiseSession,
    SetResultSession,
    GetPromiseSession,
    GetSession
};

export default SessionService;